import {Currency} from 'src/app/shared/models/currency.model';
import Big from "big.js";
import {User} from "./user.model";

export enum TransactionType {
  ALL = 'all',
  TRADE = 'trade',
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw'
}

export class UserTransaction {
  type: string;
  currency!: Currency;
  description!: string;
  amount!: number;
  user: User;
  balance!: number;
  createdAt!: string;

  constructor(input: any = {}) {
    this.type = (input.type);
    this.currency = new Currency(input.currency);
    this.description = input.description;
    this.amount = input.amount;
    this.balance = input.balance;
    this.user = new User(input.user);
    if (this.currency.id === 'IRR') {
      this.amount = Big(this.amount).round().div(10).toNumber()
      this.balance = Big(this.balance).round().div(10).toNumber();
    }
    this.createdAt = input.created_at;
  }
}
